import { GlobalAxios } from "./../axios/axios-config";
import {
  IIsRequiredCancellation,
  INewTicketAutomationMessageRule,
  ITicketAutomationMessageRules,
} from "../models/automation-message-rules";
import { ISelectType } from "@4uhub/lib4uhub";

const TICKET_SERVICE_WHATS_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationMessageRules/";
const TICKET_ARRIVAL_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/AppointmentArrivalRule/";

export const createTicketAutomationMessageRule = (
  item: INewTicketAutomationMessageRule,
) => {
  return GlobalAxios.post(TICKET_SERVICE_WHATS_ROUTE, item);
};

export const getTicketAutomationMessageRuleById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationMessageRules>(
    TICKET_SERVICE_WHATS_ROUTE + id,
  );
};

export const updateTicketAutomationMessageRuleById = ({
  item,
  id,
}: {
  item: INewTicketAutomationMessageRule;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_SERVICE_WHATS_ROUTE + id, item);
};

export const getIsRequiredCancellation = (params?: any) => {
  return GlobalAxios.get<IIsRequiredCancellation>(
    TICKET_SERVICE_WHATS_ROUTE + "IsRequiredCancellation",
    {
      params: params,
    },
  );
};

export const listAppointmentArrivalRules = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(TICKET_ARRIVAL_RULE_ROUTE + "list", {
    params,
  });
};
